import { Component } from '@angular/core';
import { ConfigurationsBlockComponent } from '../configurations-block/configurations-block.component';
import { ConfigurationDef } from '../configurations-block/configuration-def.model';

@Component({
  templateUrl: 'global-configurations.component.html',
  standalone: true,
  imports: [ConfigurationsBlockComponent]
})
export class GlobalConfigurationsComponent {

  readonly globalConfigurations: ConfigurationDef[] = [
    { name: 'game_maintenance_mode', label: 'Maintenance Mode', type: 'bool' },
    { name: 'logs_clean_timeout', label: 'Logs Clean Timeout', type: 'number' },
  ];
}
